import { Button, Divider, Drawer, notification, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import VehicleServices from "../../../services/vehicle.services";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import TmsTable from "../../../components/tms-customs/tms-table";
import SmAddCategory from "./sm-add-category";

const SmCategories = ({ router }) => {
  const [loading, setLoading] = useState(false);
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [editFlag, setEditFlag] = useState();
  const [productId, setProductId] = useState();
  const [tmsModalVisible, settmsModalVisible] = useState(false);
  const [viewAddCategoryData, setViewAddCategoryData] = useState();
  const [updateFlag, setUpdateFlag] = useState(0);

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await VehicleServices.getCategorys();
      setTableData(response);
      setTabelTotalSize(response.total);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(error, "Failed to fetch category", router);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [editFlag, tableCurrentPage, tablePageSize, updateFlag]);

  const columns = [
    {
      title: "Name",
      dataIndex: "categoryName",
      key: "categoryName",
    },
    {
      title: "Color Code",
      dataIndex: "colorCode",
      key: "colorCode",
      render: (record) => {
        console.log(record);
        return (
          <div
            style={{
              backgroundColor: `#${record}`,
              width: "20px",
              height: "10px",
            }}
          />
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <>
          <a
            onClick={async () => {
              setLoading(true);
              try {
                const categoryData = await VehicleServices.getCategoryById(
                  record?.categoryId
                );
                setViewAddCategoryData(categoryData);
                settmsModalVisible(true);
                setEditFlag(true);
                setProductId(record?.key);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
          >
            <EditOutlined />
          </a>
          <Divider type="vertical" />
          <Popconfirm
            title="Are you sure delete this Category?"
            onConfirm={async () => {
              setLoading(true);
              try {
                await VehicleServices.deleteCategories(record?.categoryId);
                notification.success({
                  message: "Category Deleted Successful",
                });
                setUpdateFlag(Math.Random + 1);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
            okText="Yes"
            cancelText="No"
          >
            <a>
              <DeleteOutlined />
            </a>
          </Popconfirm>{" "}
        </>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: "flex" }}>
        <Button
          type="primary"
          onClick={() => {
            settmsModalVisible(true);
          }}
        >
          Add New Category
        </Button>
      </div>
      <br />
      <div>
        <TmsTable
          columns={columns}
          loading={loading}
          dataSource={tableData}
          handleTableChange={handleTableChange}
          pagination={{
            total: tableTotalSize,
            current: tableCurrentPage,
            pageSize: tablePageSize,
          }}
        />
      </div>
      <Drawer
        className="DetailsModal"
        width={editFlag ? "800px" : "600px"}
        visible={tmsModalVisible}
        onClose={() => {
          settmsModalVisible(false);
          setEditFlag(false);
          setViewAddCategoryData(null);
        }}
        title={editFlag ? "Edit Category" : "Category Details"}
      >
        <SmAddCategory
          viewAddCategoryData={viewAddCategoryData}
          editFlag={editFlag}
          productId={productId}
          setEditFlag={setEditFlag}
          settmsModalVisible={settmsModalVisible}
          fetchCategories={fetchCategories}
        />
      </Drawer>
    </div>
  );
};

export default SmCategories;
